import { render, staticRenderFns } from "./CardPropertyIcon.vue?vue&type=template&id=4adc91dd&scoped=true&"
import script from "./CardPropertyIcon.vue?vue&type=script&lang=js&"
export * from "./CardPropertyIcon.vue?vue&type=script&lang=js&"
import style0 from "./CardPropertyIcon.vue?vue&type=style&index=0&id=4adc91dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc91dd",
  null
  
)

export default component.exports
import {QIcon,QTooltip,QImg} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip,QImg}, component.options.components || {})
